export function parseParams(textValue: string, paramObject: any) {
  return Object.keys(paramObject)
    .reduce(
      (text, key) => text.replace(new RegExp(`\\$\{${key}}`, 'g'), paramObject[key]),
      textValue
    );
}
